import { render, staticRenderFns } from "./Near.vue?vue&type=template&id=4fa005aa&scoped=true"
import script from "./Near.vue?vue&type=script&lang=js"
export * from "./Near.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa005aa",
  null
  
)

export default component.exports